const MDS_TAGS = {
  SYSTEM_HEALTH_BANNERS: "SystemHealthBanners"
};
const MDS_URL_SEGMENTS = {
  SYSTEM_HEALTH_BANNERS: "banners"
};
export {
  MDS_TAGS,
  MDS_URL_SEGMENTS
};
//# sourceMappingURL=common.js.map
